export const gradeHighOptions = [
  {
    value: 500,
    label: "高一",
  },
  {
    value: 600,
    label: "高二",
  },
  {
    value: 700,
    label: "高三",
  },
];

export const gradeMiddleOptions = [
  {
    value: 200,
    label: "初一",
  },
  {
    value: 300,
    label: "初二",
  },
  {
    value: 400,
    label: "初三",
  },
];

export const gradeOptions = new Array()
  .concat(gradeHighOptions)
  .concat(gradeMiddleOptions);

export const subjectOptions = [
  {
    value: 1,
    label: "语文",
  },
  {
    value: 2,
    label: "数学",
  },
  {
    value: 3,
    label: "英语",
  },
  {
    value: 6,
    label: "政治",
  },
  {
    value: 4,
    label: "历史",
  },
  {
    value: 5,
    label: "地理",
  },
  {
    value: 8,
    label: "物理",
  },
  {
    value: 9,
    label: "化学",
  },
  {
    value: 7,
    label: "生物",
  },

  // {
  //   value: 10,
  //   label: "科学"
  // },
  // {
  //   value: 11,
  //   label: "道德与法治"
  // }
];

export const examTypeOptions = [
  {
    value: 1,
    label: "单元测试",
  },
  {
    value: 2,
    label: "月考",
  },
  {
    value: 3,
    label: "期中考",
  },
  {
    value: 4,
    label: "期末考",
  },
  {
    value: 5,
    label: "周考",
  },
  {
    value: 6,
    label: "模拟考",
  },
  {
    value: 7,
    label: "专题练习",
  },
  {
    value: 8,
    label: "入学测验",
  },
  {
    value: 9,
    label: "水平会考",
  },
  {
    value: 10,
    label: "自主招生",
  },
  {
    value: 11,
    label: "联考",
  },
  {
    value: 12,
    label: "历年真题",
  },
  {
    value: 13,
    label: "竞赛题",
  },
  {
    value: 14,
    label: "课时练习",
  },
  {
    value: 15,
    label: "学业考试",
  },
  {
    value: 99,
    label: "其他",
  },
];

export const reportTypeOptions = [
  {
    value: 0,
    label: "阶段复习",
  },
  {
    value: 1,
    label: "单次考试",
  },
];

export const difficultyList = [
  {
    value: 0.9,
    label: "容易",
  },
  {
    value: 0.7,
    label: "较易",
  },
  {
    value: 0.5,
    label: "一般",
  },
  {
    value: 0.3,
    label: "较难",
  },
  {
    value: 0.1,
    label: "困难",
  },
];

export const examStateOptions = [
  {
    value: 1,
    label: "进行中",
  },
  {
    value: 2,
    label: "已结束",
  },
  {
    value: 3,
    label: "已统计",
  },
];

export const examYearOptions = [
  {
    value: "0",
    label: "全部",
  },
  {
    value: "2021",
    label: "2021 年",
  },
  {
    value: "2020",
    label: "2020 年",
  },
  {
    value: "2019",
    label: "2019 年",
  },
  {
    value: "2018",
    label: "2018 年",
  },
  {
    value: "2017",
    label: "2017 年",
  },
  {
    value: "2016",
    label: "2016 年",
  },
  {
    value: "2015",
    label: "2015 年",
  },
  {
    value: "2014",
    label: "2014 年",
  },
  {
    value: "2013",
    label: "2013 年",
  },
  {
    value: "2012",
    label: "2012 年",
  },
  {
    value: "2011",
    label: "2011 年",
  },
  {
    value: "2010",
    label: "2010 年",
  },
  {
    value: "2009",
    label: "2009 年",
  },
];

export const levelOptions = [
  {
    value: "2",
    label: "初中",
  },
  {
    value: "3",
    label: "高中",
  },
];

export const schooleYearOptions = [
  {
    value: "2022",
    label: "2022",
  },
  {
    value: "2021",
    label: "2021",
  },
  {
    value: "2020",
    label: "2020",
  },
  {
    value: "2019",
    label: "2019",
  },
  {
    value: "2018",
    label: "2018",
  },
  {
    value: "2017",
    label: "2017",
  },
];

export const examSecurityLevelOptions = [
  { value: 1, label: "低风险" },
  { value: 2, label: "高风险" },
];

export const examReportAutoSendOptions = [
  { value: "1", label: "报告自动发布" },
  { value: "2", label: "报告自动发布到老师" },
  { value: "3", label: "报告自动发布到学生" },
];

export const reportFormats = [
  { value: 1, label: "word" },
  { value: 2, label: "pdf", disabled: false },
];

export const report_units = [
  { value: 1, label: "班级" },
  { value: 2, label: "年级" },
];

export const report_user_types = [
  { value: 1, label: "学生" },
  { value: 2, label: "老师" },
];

export const optionsTime = [
  {
    value: 7,
    label: "近一周",
  },
  {
    value: 30,
    label: "近一个月",
  },
  {
    value: 90,
    label: "近三个月",
  },
  {
    value: 180,
    label: "近半年",
  },
  {
    value: 360,
    label: "近一年",
  },
  {
    value: 0,
    label: "所有",
  },
];

//题型
export const questionType = [
  {
    type: "1",
    name: "语文",
    val: [
      "论述类文本阅读",
      "实用类文本阅读",
      "文学类文本阅读",
      "文言文阅读",
      "古代诗歌阅读",
      "名篇名句默写",
      "语言文字运用",
      "作文题",
    ],
  },
  {
    type: "2",
    name: "数学",
    val: ["选择题", "填空题", "解答题"],
  },
  {
    type: "3",
    name: "英语",
    val: [
      "听力题",
      "阅读理解",
      "七选五",
      "完形填空",
      "语法填空",
      "短文改错",
      "作文题",
    ],
  },
  {
    type: "4",
    name: "历史",
    val: ["选择题", "填空题", "简答题"],
  },
  {
    type: "5",
    name: "地理",
    val: ["选择题", "填空题", "简答题"],
  },
  {
    type: "6",
    name: "政治",
    val: ["选择题", "填空题", "简答题"],
  },
  {
    type: "7",
    name: "物理",
    val: ["选择题", "单选题", "多选题", "填空题", "作图题", "解答题"],
  },
  {
    type: "8",
    name: "物理",
    val: ["选择题", "填空题", "解答题"],
  },
  {
    type: "9",
    name: "化学",
    val: ["选择题", "填空题", "解答题"],
  },
];

/*                             试卷步骤                             */
/**
 * 上传试卷
 */
export const STEP_UPLOADEXAMPAPER = 1;
/**
 * 裁切试题
 */
export const STEP_DIVIDEEXAMQUESTION = 2;
/**
 * 标注知识点
 */
export const STEP_MARKKNOWLEDGEPOINT = 3;
/**
 * 匹配变式训练题
 */
export const STEP_MATCHVARIATIONQUESTION = 4;
/**
 * 已完成所有步骤
 */
export const STEP_FINISHALL = 9;
